namespace Nobox.Nobox {
    export interface TotalResponse {
        Queue?: number;
        Process?: number;
        Sent?: number;
        Failed?: number;
        Canceled?: number;
    }
}
